import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { useState } from "react";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { addUtilityToastSuccess } from "utils/addUtilityToastSuccess";
import { ReactComponent as addRow } from "assets/addRow.svg";
import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";

export const QuickActionInsertRow = () => {
  const selectedTableId = useDataTableContext((s) => s.selectedTableId);
  const createRows = useDataTableContext((s) => s.createRows);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (selectedTableId !== undefined) {
      setIsLoading(true);
      const { error } = await createRows({
        tableId: selectedTableId,
        numRows: 1,
      });
      setIsLoading(false);

      if (error === undefined) {
        addUtilityToastSuccess("Row inserted");
      } else {
        addUtilityToastFailure("Failed to insert row");
      }
    }
  };

  return (
    <ButtonIconPermissioned
      requiredPermission="edit"
      defaultTooltip="Insert row"
      aria-label="Insert row"
      size="xs"
      iconType={addRow}
      onClick={() => void handleClick()}
      disabled={selectedTableId === undefined}
      isLoading={isLoading}
      id={"quickActionInsertRow"}
    />
  );
};
